export interface SEOData {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
}

export function getPageSEO(data: SEOData): string {
  const schemas: Record<string, unknown>[] = [];

  if (data.schema) {
    schemas.push(data.schema);
  }

  if (schemas.length === 0) return '';

  const jsonLd = JSON.stringify(
    schemas.length === 1 ? schemas[0] : { '@context': 'https://schema.org', '@graph': schemas },
    null,
    2
  );

  return jsonLd;
}

export function OrganizationSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51网址导航',
    url: 'http://chiguadao.cn/',
    logo: 'http://chiguadao.cn/logo.png',
    description: '51网址导航网汇集网址导航大全、百万网址导航等主流导航入口，同步推送最新网红黑料、明星塌房现场及独家爆料视频。',
    email: 'hello@chiguadao.cn',
    telephone: '400-888-5151',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '建国路88号SOHO现代城A座1206室',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
    sameAs: ['http://chiguadao.cn/'],
  };
}

export function WebsiteSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51网址导航',
    url: 'http://chiguadao.cn/',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'http://chiguadao.cn/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };
}

export function WebPageSchema(pageTitle: string, pageUrl: string, description: string): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: pageTitle,
    url: pageUrl,
    description: description,
    isPartOf: {
      '@type': 'WebSite',
      name: '51网址导航',
      url: 'http://chiguadao.cn/',
    },
  };
}

export function BreadcrumbListSchema(items: { name: string; url: string }[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function ArticleSchema(article: {
  title: string;
  url: string;
  description: string;
  image: string;
  datePublished: string;
  dateModified: string;
  authorName: string;
}): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    url: article.url,
    description: article.description,
    image: article.image,
    datePublished: article.datePublished,
    dateModified: article.dateModified,
    author: {
      '@type': 'Person',
      name: article.authorName,
    },
    publisher: {
      '@type': 'Organization',
      name: '51网址导航',
      logo: {
        '@type': 'ImageObject',
        url: 'http://chiguadao.cn/logo.png',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': article.url,
    },
  };
}

export function FAQPageSchema(faqs: { question: string; answer: string }[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}